import type { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import type { IconPropsT } from './Icon';
import Icon from './Icon';

const AllScheduleIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="8"
        fill={theme.colors.primary.variant1}
        viewBox="0 0 14 8"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M9.60896 0.175736C9.38146 -0.0517638 9.01396 -0.0517638 8.78646 0.175736L5.49646 3.46574L6.31896 4.28824L9.60896 0.992403C9.83063 0.770736 9.83063 0.397403 9.60896 0.175736ZM12.0823 0.169903L6.31896 5.93324L4.28896 3.90907C4.06146 3.68157 3.69396 3.68157 3.46646 3.90907C3.23896 4.13657 3.23896 4.50407 3.46646 4.73157L5.90479 7.1699C6.13229 7.3974 6.49979 7.3974 6.72729 7.1699L12.9048 0.998236C13.1323 0.770736 13.1323 0.403236 12.9048 0.175736H12.899C12.6773 -0.0575972 12.3098 -0.0575973 12.0823 0.169903ZM0.170625 4.7374L2.60896 7.17574C2.83646 7.40324 3.20396 7.40324 3.43146 7.17574L3.83979 6.7674L0.993125 3.90907C0.765625 3.68157 0.398125 3.68157 0.170625 3.90907C-0.056875 4.13657 -0.056875 4.5099 0.170625 4.7374Z"
          fill="black"
          fill-opacity="0.54"
        />
      </svg>
    </Icon>
  );
};

export default AllScheduleIcon;
